import { TERMS_VERSION } from '@/lib/legal';

const KEY = 'nm.onboarding';

export interface OnboardingDraft {
  acceptedAge18: boolean;
  acceptedTerms: boolean;
  acceptedLocation: boolean;
  dob: string; // yyyy-mm-dd
  termsVersion: string;
}

const EMPTY: OnboardingDraft = {
  acceptedAge18: false,
  acceptedTerms: false,
  acceptedLocation: false,
  dob: '',
  termsVersion: TERMS_VERSION,
};

export function getDraft(): OnboardingDraft {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? { ...EMPTY, ...(JSON.parse(raw) as Partial<OnboardingDraft>) } : { ...EMPTY };
  } catch {
    return { ...EMPTY };
  }
}

export function saveDraft(patch: Partial<OnboardingDraft>): OnboardingDraft {
  const next = { ...getDraft(), ...patch, termsVersion: TERMS_VERSION };
  try {
    sessionStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}

export function clearDraft(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/** True once the terms gate is fully satisfied (all consents + adult DOB). */
export function consentComplete(d: OnboardingDraft): boolean {
  return d.acceptedAge18 && d.acceptedTerms && d.acceptedLocation && isAdult(d.dob);
}

export function isAdult(dob: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dob)) return false;
  const birth = new Date(dob + 'T00:00:00');
  if (Number.isNaN(birth.getTime())) return false;
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  const m = now.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age--;
  return age >= 18;
}
